import React from 'react';
import { useIntl } from 'react-intl';
import productImage from '../public/product.png';

export const CheckupProductSchema: React.FC = () => {
  const { messages } = useIntl();
  const productImageURL = new URL(productImage, window.location.href);
  const productURL = new URL(window.location.href);
  const minPrice = 1495;
  const maxPrice = 1695;

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: messages['product.health_checkup.title'],
    image: [`${productImageURL}`],
    description: messages['checkup.summary'],
    sku: 'health_checkup',
    brand: {
      '@type': 'Thing',
      name: messages['unika.name'],
    },
    offers: {
      '@type': 'AggregateOffer',
      url: `${productURL}`,
      priceCurrency: 'SEK',
      lowPrice: minPrice.toFixed(2),
      highPrice: maxPrice.toFixed(2),
      itemCondition: 'https://schema.org/NewCondition',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: messages['unika.name'],
      },
    },
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema, undefined, 2)}
    </script>
  );
};
